import React, { useEffect, useState } from "react";
import { Button, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faChevronRight,
  faCircleXmark,
  faClock,
  faEdit,
  faSpinner,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";

import { BookingItemType, PaginationType } from "../../../Constants/Interfaces";
import { getAdminBookingListAction } from "../../../Services/Store/Actions/BookingsAction";
import RightSlidingPanel from "./RightSlidingPanel";
import BookingInfoPanel from "../../User/Components/BookingList/BookingInfoPanel";
import ActionMenu from "../../../Components/ActionMenu";
import Pagination from "../../../Components/Pagination";

interface AdminBookingListType {
  search: string;
}

const AdminBookingList: React.FC<AdminBookingListType> = ({ search = "" }) => {
  const dispatch = useDispatch();

  const { adminBookingList } = useSelector((state: any) => state.bookings);

  const [loading, setLoading] = useState(false);
  const [bookings, setBookings] = useState<BookingItemType[] | []>([]);
  const [pagination, setPagination] = useState<PaginationType | null>(null);

  const [rightSidePanel, setRightSidePanel] = useState<{
    show: boolean;
    item: BookingItemType | null;
  }>({
    show: false,
    item: null,
  });

  const getBookingsList = (page: number) => {
    if (!loading) {
      setLoading(true);
      const params = {
        page,
        limit: 20,
        search,
      };

      getAdminBookingListAction(params, dispatch)
        .then((res) => {
          if (res.type === "success") {
            setPagination(res.pagination);
          }
        })
        .catch((err) => {
          console.log("ERR: ", err);
        })
        .finally(() => setLoading(false));
    }
  };

  useEffect(() => {
    setBookings(adminBookingList);
  }, [adminBookingList]);

  useEffect(() => {
    getBookingsList(1);
  }, []);

  return (
    <>
      <div className="listing-tables">
        <Table responsive>
          <thead>
            <tr>
              <th>Space Name</th>
              <th>Amount</th>
              <th>Booking Date</th>
              <th style={{ width: 100, textAlign: "center" }}>Status</th>
              <th className="action-col">Action</th>
            </tr>
          </thead>

          <tbody>
            {!loading && bookings.length === 0 && (
              <tr>
                <td colSpan={5} align="center">
                  No Bookings available
                </td>
              </tr>
            )}
            {bookings.length > 0 &&
              bookings.map((item, index) => (
                <tr key={`booking-${item.id}`}>
                  <td>{item?.space?.name || ""}</td>
                  <td>${item?.grossAmount}</td>
                  <td>
                    {item &&
                      item.startDate &&
                      moment(item.startDate).format("MM/DD/YYYY")}
                  </td>
                  <td align="center">
                    {(item?.status === "accepted" ||
                      item?.status === "completed") && (
                      <span
                        className="status-icons text-success"
                        title="Success"
                      >
                        <FontAwesomeIcon icon={faCheckCircle} />
                      </span>
                    )}

                    {item?.status === "payment-pending" && (
                      <span
                        className="status-icons text-warning"
                        title="Pending"
                      >
                        <FontAwesomeIcon icon={faClock} />
                      </span>
                    )}

                    {item?.status === "failed" ||
                      (item?.status === "cancelled" && (
                        <span
                          className="status-icons text-danger"
                          title={
                            item?.status === "failed" ? "Failed" : "Cancelled"
                          }
                        >
                          <FontAwesomeIcon icon={faCircleXmark} />
                        </span>
                      ))}
                  </td>
                  <td className="action-col">
                    <ActionMenu
                      items={[
                        {
                          label: "Details",
                          icon: faChevronRight,
                          onClick: () =>
                            setRightSidePanel({ show: true, item }),
                        },
                      ]}
                    />
                  </td>
                </tr>
              ))}

            {loading && (
              <tr>
                <td colSpan={5} align="center">
                  <FontAwesomeIcon icon={faSpinner} spin />
                </td>
              </tr>
            )}
          </tbody>

          <tfoot>
            <tr>
              <td colSpan={5}>
                <Pagination
                  pagination={pagination}
                  onPageChange={(page) => getBookingsList(page)}
                />
              </td>
            </tr>
          </tfoot>
        </Table>
      </div>

      {rightSidePanel.show && (
        <RightSlidingPanel
          title={`Booking Info`}
          show={rightSidePanel.show}
          onClosePanel={() => setRightSidePanel({ show: false, item: null })}
        >
          <BookingInfoPanel
            showActionBtns="No"
            item={rightSidePanel.item}
            listType="paid"
            closePanel={() => setRightSidePanel({ show: false, item: null })}
          />
        </RightSlidingPanel>
      )}
    </>
  );
};

export default AdminBookingList;
